import { zIdName } from "src/types/ZIdName";
import { zUid } from "src/types/zUid";
import z from "zod";

const zBom3MatrixCell = z.object({
  rowId: zUid,
  columnId: zUid,
  enabled: z.boolean(),
});

export const zBom3MatrixSettings = z.object({
  columns: zIdName.array(),
  rows: zIdName.array(),
  cells: zBom3MatrixCell.array(),
});
export type ZBom3MatrixSettings = z.infer<typeof zBom3MatrixSettings>;

export const zBom3Settings = z.object({
  objBom: zUid.nullish(),
  objBomPosition: zUid.nullish(),
  objMaterial: zUid.nullish(),
  objColor: zUid.nullish(),
  objColorModel: zUid.nullish(),
  dictBomSection: zUid.nullish(),
  dictMaterialType: zUid.nullish(),
  attBomPositionLinkToMaterial: zUid.nullish(),
  attBomPositionColorLinks: zUid.nullish(),
  attMaterialType: zUid.nullish(),
  attColorLinkToModel: zUid.nullish(),
  directoryMatrix: zBom3MatrixSettings.nullish(),

  // LPLM-4992 размерные вариации для фурнитуры и упаковки
  sizeVariations: z.boolean(), // В апи этого поля нет, но оно формируется при загрузке. Иначе невозможно управлять видимостью соответствующих полей
  objSizeLine: zUid.nullish(),
  objSizeName: zUid.nullish(),
  objMaterialSize: zUid.nullish(),
  attLinkSizeNameToSizeLine: zUid.nullish(),
  attLinkBomToSizeLine: zUid.nullish(),
  attLinkMaterialSizeToMaterial: zUid.nullish(),
  attLinkBomPositionToSizeVariation: zUid.nullish(),
  attLinkBomToModel: zUid.nullish(),

  consumptionBySize: z.boolean().nullish(),

  commonSumma: z.boolean(), // Искуственно формируется так же, как и sizeVariations
  attBomTotalAmount: zUid.nullish(),
  attBomPositionAmount: zUid.nullish(),

  // LPLM-5675 Доработка для использования ВОМ для разных категорий товаров
  attModelDictProductCategory: zUid.nullish(), // атрибут в модели
  productCategoryMatrix: zBom3MatrixSettings.nullish(),
});

export type ZBom3Settings = z.infer<typeof zBom3Settings>;
